import { render, staticRenderFns } from "./JArrow.vue?vue&type=template&id=e9045792&scoped=true&"
import script from "./JArrow.vue?vue&type=script&lang=js&"
export * from "./JArrow.vue?vue&type=script&lang=js&"
import style0 from "./JArrow.vue?vue&type=style&index=0&id=e9045792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9045792",
  null
  
)

export default component.exports